import "scroll-behavior-polyfill";
import SmoothScroll from "smooth-scroll";
import slick from 'slick-carousel';

// fadeIn
function fadeIn(elm, ms) {
  elm.style.opacity = 0; // 透過度０
  elm.style.display = "block";
  elm.style.transition = "opacity " + ms + "ms";
  setTimeout(function () {
    elm.style.opacity = 1;
  }, 1); // 0.001秒後に transition開始(透過度１にする）
}
// fadeOut
function fadeOut(elm, ms) {
  elm.style.opacity = 1; // 透過度1
  elm.style.transition = "opacity " + ms + "ms";
  setTimeout(function () {
    elm.style.opacity = 0;
  }, 1); // 0.001秒後に transition開始（透過度0にする）
  setTimeout(function () {
    elm.style.display = "none";
  }, ms + 10); // 1.01秒後に完全に消す。
}



$(document).ready(function(){
  $('.slickBox').slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay:true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
});


const dDown = document.querySelectorAll(".dDown > li");
dDown.forEach(function(i){
  const head = i.querySelector(".head");
  const cont = i.querySelector(".cont");
  head.addEventListener("click",function(){
    if(head.dataset.flg === "false"){
      head.dataset.flg = 'true';
    }else{
      head.dataset.flg = 'false';
    }
  })
})


const privacypolicy = document.querySelector(".privacypolicy");
const close = privacypolicy.querySelector("#close");
const agree = document.querySelector(".agree");

agree.addEventListener("click",function(){
  fadeIn(privacypolicy,100);
})
close.addEventListener("click",function(){
  fadeOut(privacypolicy,100);
})

var scroll = new SmoothScroll('a[href*="#"]', {
  header: '[data-scroll-header]',
  speed: 100,
});

